import React from "react";
import download from "../../assets/icons/download.svg";
import config from "../../config";

export default function InsuranceBreakDownUploadedFile({ file }) {
  // Check if the file is a PDF
  const isPDF = (file.document && file.document.endsWith(".pdf")) || file.type === "application/pdf";

  return (
    <div
      style={{
        width: 200,
        height: 133,
        cursor: "pointer",
      }}
    >
      <a href={config.apiGateway.URL + file.document} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
        <div
          style={{
            border: "1px solid #6B43B5",
            borderRadius: 8,
            width: 200,
            height: 133,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {isPDF ? (
            <>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <iframe
                  src={`${config.apiGateway.URL + file.document}#view=fitH&toolbar=0&navpanes=0&scrollbar=0`}
                  style={{
                    width: "calc(100% + 20px)", // Compensate for scrollbar
                    height: "100%",
                    border: "none",
                    pointerEvents: "none",
                    position: "absolute",
                    top: 0,
                    left: 0,
                  }}
                  title="PDF Preview"
                  scrolling="no"
                />
              </div>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: "5",
                  width: 30,
                  height: 30,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#6B43B5",
                  borderRadius: "50%",
                  padding: 5,
                  opacity: 0.8,
                }}
              >
                <img width={15} height={15} src={download} alt="download" />
              </div>
            </>
          ) : (
            <>
              <div style={{ fontSize: 50, color: "#6B43B5" }}>{/* Placeholder for non-PDF files */}</div>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: "5",
                  width: 30,
                  height: 30,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#6B43B5",
                  borderRadius: "50%",
                  padding: 5,
                  opacity: 0.8,
                }}
              >
                <img width={15} height={15} src={download} alt="download" />
              </div>
            </>
          )}
        </div>
      </a>
    </div>
  );
}
